import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { HandleMissedActivitiesJustificationsUseCaseInterface } from 'domain/usecases';

export class RemoteHandleMissedActivitiesJustifications
  implements HandleMissedActivitiesJustificationsUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<HandleMissedActivitiesJustificationsUseCaseInterface.Result>,
  ) {}

  async execute(
    params: HandleMissedActivitiesJustificationsUseCaseInterface.Params,
  ): Promise<HandleMissedActivitiesJustificationsUseCaseInterface.Result> {
    const { type, ...rest } = params;

    const url = `${this.url}/${type}`;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const requestUrl = generateUrl(url, rest as any);

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
      responseType: params.type === '2' ? 'json' : 'arraybuffer',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
